import { useEffect } from 'react';

import autosize from 'autosize';
import PropTypes from 'prop-types';

import { Input, InputGroup } from 'components/FormComponents';

export const Text = ({
  name,
  label,
  autoComplete,
  placeholder,
  defaultValue,
  minLength,
  maxLength,
  validators = {},
  disabled,
  register = () => {},
  error = '',
  noErrorMessage,
  className,
  inputProps = {},
  readOnly = false,
  hidden = false,
}) => {
  return (
    <InputGroup title={label} hidden={hidden}>
      <Input
        name={name}
        placeholder={placeholder}
        defaultValue={defaultValue}
        minLength={minLength}
        maxLength={maxLength}
        disabled={disabled}
        className={className}
        autoComplete={autoComplete}
        register={register}
        validators={validators}
        error={error}
        noErrorMessage={noErrorMessage}
        readOnly={readOnly}
        {...inputProps}
      />
    </InputGroup>
  );
};

Text.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  autoComplete: PropTypes.string,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  validators: PropTypes.object,
  register: PropTypes.func,
  error: PropTypes.string,
  noErrorMessage: PropTypes.bool,
  className: PropTypes.string,
  inputProps: PropTypes.object,
};
